import { render, staticRenderFns } from "./CreatePtZy.vue?vue&type=template&id=5ad2bf5f&scoped=true"
import script from "./CreatePtZy.vue?vue&type=script&lang=js"
export * from "./CreatePtZy.vue?vue&type=script&lang=js"
import style0 from "./CreatePtZy.vue?vue&type=style&index=0&id=5ad2bf5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2bf5f",
  null
  
)

export default component.exports